const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

export const TimeTrackerConstants = {
  SECOND,
  MINUTE,
  HOUR,
};
